"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetRequestT = exports.ResetRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const reset_type_js_1 = require("../../solarxr-protocol/rpc/reset-type.js");
class ResetRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsResetRequest(bb, obj) {
        return (obj || new ResetRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsResetRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new ResetRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    resetType() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : reset_type_js_1.ResetType.Yaw;
    }
    /**
     * Which body parts to reset. Server handles it if empty (usually all)
     */
    bodyParts(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    bodyPartsLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    bodyPartsArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    delay() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    static startResetRequest(builder) {
        builder.startObject(3);
    }
    static addResetType(builder, resetType) {
        builder.addFieldInt8(0, resetType, reset_type_js_1.ResetType.Yaw);
    }
    static addBodyParts(builder, bodyPartsOffset) {
        builder.addFieldOffset(1, bodyPartsOffset, 0);
    }
    static createBodyPartsVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startBodyPartsVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addDelay(builder, delay) {
        builder.addFieldFloat32(2, delay, 0);
    }
    static endResetRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createResetRequest(builder, resetType, bodyPartsOffset, delay) {
        ResetRequest.startResetRequest(builder);
        ResetRequest.addResetType(builder, resetType);
        ResetRequest.addBodyParts(builder, bodyPartsOffset);
        if (delay !== null)
            ResetRequest.addDelay(builder, delay);
        return ResetRequest.endResetRequest(builder);
    }
    unpack() {
        return new ResetRequestT(this.resetType(), this.bb.createScalarList(this.bodyParts.bind(this), this.bodyPartsLength()), this.delay());
    }
    unpackTo(_o) {
        _o.resetType = this.resetType();
        _o.bodyParts = this.bb.createScalarList(this.bodyParts.bind(this), this.bodyPartsLength());
        _o.delay = this.delay();
    }
}
exports.ResetRequest = ResetRequest;
class ResetRequestT {
    constructor(resetType = reset_type_js_1.ResetType.Yaw, bodyParts = [], delay = null) {
        this.resetType = resetType;
        this.bodyParts = bodyParts;
        this.delay = delay;
    }
    pack(builder) {
        const bodyParts = ResetRequest.createBodyPartsVector(builder, this.bodyParts);
        return ResetRequest.createResetRequest(builder, this.resetType, bodyParts, this.delay);
    }
}
exports.ResetRequestT = ResetRequestT;
